module.exports = __webpack_public_path__ + "static/media/logo-4.c5d5724b.png";